

export const serviceList = [
    {name: "钱包提现", path: "/extract", icon: require('../assets/img/qb-icon.png')},
    {name: "钱包充值", path: "/wallet", icon: require('../assets/img/zl-icon.png')},
    {name: "转账", path: "/loan", icon: require('../assets/img/jkxx-icon.png')},
]